import { render, staticRenderFns } from "./recommend-list.vue?vue&type=template&id=b0082300&scoped=true"
import script from "./recommend-list.vue?vue&type=script&lang=js"
export * from "./recommend-list.vue?vue&type=script&lang=js"
import style0 from "./recommend-list.vue?vue&type=style&index=0&id=b0082300&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0082300",
  null
  
)

export default component.exports